import styled from 'styled-components';
import theme from '../../styles/defaultTheme';

export const FooterContainer = styled.footer`
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    background-color: ${(props) => props.theme.white};
    border-top: 1px solid ${(props) => props.theme.borderWhite};
    padding: 20px 0;
`;

export const TextFooter = styled.div`
    width: 560px;
    font: ${theme.font.body[7]};
    letter-spacing: 0px;
    color: ${(props) => props.theme.grey};
    padding: 0 32px 0 0;
    font: inherit;
`;

export const SecondTextFooter = styled(TextFooter)`
    width: 336px;
    display: flex;
    flex-direction: column;
`;

export const AlignSection = styled.div`
    display: flex;
    align-items: center;
`;
